import type { UserConfigDto, UserConfigRequestDto } from '../dto';
import type { UserConfig, UserConfigRequest } from '../models';

export const mapUserTableConfigDtoToModel = (
  dto: UserConfigDto,
): UserConfig => ({ ...dto });

export const mapUserTableConfigsListDtoToModel = (
  dtos: UserConfigDto[],
): UserConfig[] => dtos.map(mapUserTableConfigDtoToModel);

export const mapUserTableConfigRequestModelToDto = (
  request: UserConfigRequest,
): UserConfigRequestDto => ({
  ...request,
  columnConfiguration: { ...request.columnConfiguration },
});
